import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SwStateMachineService } from '../services/sw-state-machine.service';
import { Subscription } from 'rxjs';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NgStyle } from '@angular/common';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzModalComponent, NzModalContentDirective } from 'ng-zorro-antd/modal';
import { LocationFormComponent } from './location-form/location-form.component';
import { MetaWindow } from '@aaa/emember/types';

@Component({
  selector: 'ava-smart-weather-list',
  standalone: true,
  template: `
    <div #container>
      @for (location of locations; track location; let first = $first; let last = $last) {
        @if (first) {
          <nz-divider [style]="'margin: 10px 0'" />
        }

        <div [style]="'display: grid; align-items: center'" [ngStyle]="locationRowStyles">
          <div [style]="'text-align: left'">
            {{ location.name }}
          </div>
          <div
            [style]="'display: grid; column-gap: 20px; grid-template-columns: 1fr 1fr'"
            [ngStyle]="buttonWrapperStyles"
          >
            <button nz-button nzType="primary" (click)="swSms.sendEvent('EDIT', location.index)">Edit</button>
            <button nz-button nzType="primary" (click)="swSms.sendEvent('DELETE', location.index)">Delete</button>
          </div>
        </div>

        @if (!last || true) {
          <nz-divider [style]="'margin: 10px 0'" />
        }
      }

      <div [style]="'display: grid'" [ngStyle]="addAlertRowStyles">
        <div></div>

        @if (state.value !== 'cloudSyncError' && locations?.length < 5 && state.value !== 'cloudSync') {
          <button nz-button nzType="primary" (click)="swSms.sendEvent('EDIT', locations?.length)">Add New Alert</button>
        }
      </div>
    </div>

    <nz-modal [(nzVisible)]="isVisible" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" [nzFooter]="" nzWidth="90%">
      <ava-smart-weather-location-form
        *nzModalContent
        [eventIndex]="state.event.index"
        [title]="formTitle"
      ></ava-smart-weather-location-form>
    </nz-modal>
  `,
  imports: [
    NzDividerComponent,
    NgStyle,
    NzButtonComponent,
    NzModalComponent,
    LocationFormComponent,
    NzModalContentDirective,
  ],
})
export class ListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('container') container: ElementRef | undefined;
  containerWidth: number | undefined;
  buttonWrapperStyles: { [key: string]: string } = {};
  locationRowStyles: { [key: string]: string } = {};
  addAlertRowStyles: { [key: string]: string } = {};
  bp = { sm: false, md: false };
  private stateSubscription?: Subscription;
  state: any;
  locations: any[] = [];
  isVisible = false;
  formTitle?: string;
  window: MetaWindow;

  constructor(
    public swSms: SwStateMachineService,
    public domWindow: Window,
  ) {
    this.window = domWindow as unknown as MetaWindow;
  }

  ngOnInit(): void {
    this.stateSubscription = this.swSms.state$.subscribe((state) => {
      if (state) {
        this.state = state;
        this.isVisible = state.value === 'location' && state.event && state.event.type !== 'DELETE';
        this.formTitle = 'Edit Weather Alert';
        if (state.event.index === state.context.locations?.length) {
          this.formTitle = 'Create New Weather Alert';
        }
        if (state.context.locations) {
          this.locations = state.context.locations;
          this.locations = this.locations.map((location, index) => {
            location['index'] = index;
            return location;
          });
          this.locations = this.locations?.sort((a, b) => (a.name > b.name ? 1 : -1));
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.onResize();
  }

  ngOnDestroy(): void {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.swSms.sendEvent('CANCEL');
    this.isVisible = false;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.containerWidth = this.container?.nativeElement.offsetWidth;

    this.locationRowStyles = { 'grid-template-columns': '1fr' };
    this.addAlertRowStyles = { 'grid-template-columns': '1fr' };
    if (this.containerWidth && this.containerWidth >= 700) {
      this.locationRowStyles = { 'grid-template-columns': '1fr 1fr' };
      this.addAlertRowStyles = { 'grid-template-columns': '1fr 1fr' };
    }
  }
}
